import type { StockHealth } from '../../status-colors.ts';
import styles from './StockGauge.module.css';

const BARS = 4;
const UNITS_PER_BAR = 15;
const FEWEST_HEALTHY_BARS = 2;

const filledBars = (health: StockHealth, available: number): number => {
  if (health === 'out') return 0;
  if (health === 'low') return 1;
  return Math.min(BARS, Math.max(FEWEST_HEALTHY_BARS, Math.ceil(available / UNITS_PER_BAR)));
};

export type StockGaugeProps = { health: StockHealth; available: number };

export const StockGauge = ({ health, available }: StockGaugeProps) => {
  const filled = filledBars(health, available);
  return (
    <span className={styles['gauge']} data-health={health} aria-hidden="true">
      {Array.from({ length: BARS }, (_, index) => (
        <span key={index} className={styles['bar']} data-filled={index < filled} />
      ))}
    </span>
  );
};
